import { useGlobalStore } from '../store'

const useUpdateLhs = () => {
  const { setSubLhsApiLoaded, isPPTModalActive } = useGlobalStore()

  const updateSubLhsApiLoaded = (id) => {
    if (!isPPTModalActive) return

    // Delay the execution
    setTimeout(() => {
      const updatingSubLhs = { ['id-' + id.InsightsElementId]: true }
      setSubLhsApiLoaded(updatingSubLhs)
    }, 1500) // 300ms delay (adjust as needed
  }

  return { updateSubLhsApiLoaded }
}

export { useUpdateLhs }
